<template>
  <div id="teacher_seminar">
    <div class="over_ta">
      <ul style="margin-top: 20px;">
        <li style="list-style: inside;" v-for="(teacherpublication,index) in teacherpublications" :key="index" v-if="teacherpublication.type === 1">
          <span v-if="teacherpublication.context">
            {{teacherpublication.context}}
          </span> 
          <span v-else>
            <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.author)">
            </div>, {{publication(teacherpublication)}},
            <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.title)">
            </div>, {{showName(teacherpublication)}}, {{publicationmonth(teacherpublication)}},
            <span v-if="teacherpublication.memo">({{teacherpublication.place}}), </span><span v-if="teacherpublication.memo">({{teacherpublication.memo}})</span>
          </span> 
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_seminar',
  props: ['teacher', 'teacherpublications'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {},
  methods: {
    publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        let dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0]
      }
      return ''
    },
    publicationmonth(teacherpublication) {
      if (teacherpublication.publicationAt) {
        let dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        switch (dateArr[1]) {
          case '01':
            return 'January'
            break;
          case '02':
            return 'February'
            break;
          case '03':
            return 'March'
            break;
          case '04':
            return 'April'
            break;
          case '05':
            return 'May'
            break;
          case '06':
            return 'June'
            break;
          case '07':
            return 'July'
            break;
          case '08':
            return 'August'
            break;
          case '09':
            return 'September'
            break;
          case '10':
            return 'October'
            break;
          case '11':
            return 'November'
            break;
          case '12':
            return 'December'
            break;
          default:
            break;
        }
      }
      return ''
    },
    

    showName(teacherpublication) {
      let name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn }
      return name[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#teacher_seminar {
  table {
    tr {
      td {
        padding: 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TeacherSeminar.vue?02e4b2f8